module.exports = __webpack_public_path__ + "static/flags/fr-326505628dd29d08429b5ea79f489c36.svg";